var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarouselArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#4375C5",
    fillOpacity: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "url(#paint0_radial_5490_417238)",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4393 80.5542H70.0643L52.406 58.2459L75.0977 35.5542H59.0643C57.681 35.5542 56.5643 36.6709 56.5643 38.0542C56.5643 39.4375 57.681 40.5542 59.0643 40.5542H63.031L45.7227 57.8625L59.731 75.5542H47.6893L29.2727 54.7292C28.356 53.6959 26.7727 53.5959 25.7477 54.5125C24.7143 55.4292 24.6143 57.0042 25.531 58.0375L45.4477 80.5459L45.4393 80.5542Z",
    fill: "#6DFBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5549 51.3042C35.2216 51.3042 35.8966 51.0375 36.3882 50.5042L58.8882 26.3375C59.8299 25.3292 59.7716 23.7458 58.7632 22.8042C57.7549 21.8625 56.1716 21.9208 55.2299 22.9292L32.7299 47.0958C31.7882 48.1042 31.8466 49.6875 32.8549 50.6292C33.3382 51.0792 33.9466 51.2958 34.5549 51.2958V51.3042Z",
    fill: "#6DFBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8889 34.4458C26.8889 34.4458 26.0889 35.2541 26.0889 36.2458C26.0889 37.2375 26.8973 38.0458 27.8889 38.0458C28.8806 38.0458 29.6973 37.2375 29.6973 36.2458C29.6973 35.2541 28.8889 34.4458 27.8889 34.4458Z",
    fill: "#6DFBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6893 27.7792C32.2143 27.7792 31.0143 28.9792 31.0143 30.4542C31.0143 31.9292 32.2143 33.1292 33.6893 33.1292C35.1643 33.1292 36.3643 31.9292 36.3643 30.4542C36.3643 28.9792 35.1643 27.7792 33.6893 27.7792Z",
    fill: "#6DFBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6969 19.4458C37.8553 19.4458 36.3636 20.9375 36.3636 22.7791C36.3636 24.6208 37.8553 26.1125 39.6969 26.1125C41.5386 26.1125 43.0303 24.6208 43.0303 22.7791C43.0303 20.9375 41.5386 19.4458 39.6969 19.4458Z",
    fill: "#6DFBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5490_417238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.747 51.3158) rotate(90) scale(97.1053 69.5367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F94D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F94D3",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarouselArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carousel-arrow-left.61b9ba8c6609d4faef65aab2b4640b14.svg";